import { render, staticRenderFns } from "./MessageProfileImage.vue?vue&type=template&id=48d4cb32"
import script from "./MessageProfileImage.vue?vue&type=script&lang=js"
export * from "./MessageProfileImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports